!(function () {
  "use strict";

  const COOKIE_NAME = "shopify_recently_viewed";
  const STORE_LIMIT = 10;

  const readHandles = () => {
    const prefix = `${COOKIE_NAME}=`;
    const row = document.cookie
      .split("; ")
      .find((part) => part.startsWith(prefix));
    if (!row) return [];
    return decodeURIComponent(row.slice(prefix.length))
      .split(" ")
      .filter(Boolean);
  };

  const writeHandles = (handles) => {
    const expires = new Date();
    expires.setTime(expires.getTime() + 90 * 24 * 3600 * 1000);
    document.cookie = `${COOKIE_NAME}=${encodeURIComponent(handles.join(" "))}; expires=${expires.toUTCString()}; path=/; SameSite=Lax`;
  };

  const recordHandle = (handle) => {
    if (!handle) return;
    const next = readHandles().filter((item) => item !== handle);
    next.unshift(handle);
    writeHandles(next.slice(0, STORE_LIMIT));
  };

  window.theme = window.theme || {};
  window.theme.recordRecentlyViewed = recordHandle;

  customElements.get("recently-viewed") ||
    customElements.define(
      "recently-viewed",
      class extends HTMLElement {
        constructor() {
          super();
          this.section = this.closest("[data-section-type]");
          this.target = this.dataset.target || "api-product-grid-item";
          this.wrapperId = this.dataset.wrapperId || this.id;

          const parsedLimit = parseInt(this.dataset.limit, 10);
          if (this.hasAttribute("data-show-all")) {
            this.howManyToShow = 50;
          } else if (!Number.isNaN(parsedLimit) && parsedLimit > 0) {
            this.howManyToShow = parsedLimit;
          } else {
            this.howManyToShow = 4;
          }
        }

        connectedCallback() {
          if (this.dataset.recordHandle) {
            recordHandle(this.dataset.recordHandle);
          }

          this.loadProducts().finally(() => this.markReady());
        }

        markReady() {
          this.setAttribute("data-recently-viewed-ready", "");
          this.dispatchEvent(
            new CustomEvent("theme:recently-viewed:loaded", {
              bubbles: true,
            }),
          );
        }

        getWrapper() {
          return document.getElementById(this.wrapperId) || this;
        }

        handlesToShow() {
          const exclude = this.dataset.excludeHandle;
          return readHandles()
            .filter((handle) => handle !== exclude)
            .slice(0, this.howManyToShow);
        }

        async loadProducts() {
          if (window.Shopify?.visualPreviewMode) return;

          const handles = this.handlesToShow();
          const wrapper = this.getWrapper();
          if (!handles.length || !wrapper) return;

          const root = window.theme?.routes?.root || "/";

          for (let index = 0; index < handles.length; index += 1) {
            const handle = handles[index];
            try {
              const response = await fetch(
                `${root}products/${encodeURIComponent(handle)}?section_id=${this.target}`,
              );
              if (!response.ok) continue;

              const html = await response.text();
              const content = new DOMParser()
                .parseFromString(html, "text/html")
                .querySelector("[data-api-content]");
              if (!content) continue;

              let markup = content.innerHTML;
              if (markup.includes("||itemAnimationDelay||")) {
                markup = markup.replaceAll(
                  "||itemAnimationDelay||",
                  String(index * 100),
                );
              }
              if (markup.includes("||itemAnimationAnchor||")) {
                markup = markup.replaceAll(
                  "||itemAnimationAnchor||",
                  wrapper.id ? `#${wrapper.id}` : "",
                );
              }

              wrapper.insertAdjacentHTML("beforeend", markup);
            } catch (error) {
              // Skip handles that cannot be fetched (deleted/unpublished).
            }
          }

          if (wrapper.children.length) {
            wrapper.classList.remove("hidden");
          }
        }
      },
    );
})();
